import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getsampleCategoriesHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "sampleCategory", ...action.payload }),
		);
		yield put({
			type: types.GET_SAMPLE_CATEGORIES_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_SAMPLE_CATEGORIES_ERROR,
			payload,
		});
	}
}

export function* getsampleCategoriesWatcherSaga() {
	yield takeLatest(
		types.GET_SAMPLE_CATEGORIES_START,
		getsampleCategoriesHandlerSaga,
	);
}

//create

//delete

function* deletesampleCategoriesHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("sampleCategory", action.payload),
		);
		yield put({
			type: types.DELETE_SAMPLE_CATEGORIES_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_SAMPLE_CATEGORIES_ERROR,
			payload,
		});
	}
}

export function* deletesampleCategoriesWatcherSaga() {
	yield takeLatest(
		types.DELETE_SAMPLE_CATEGORIES_START,
		deletesampleCategoriesHandlerSaga,
	);
}

//update
